import { Reducer, createContext } from 'react';
import { Case, Feedback, QueueConfiguration, CaseSummary } from 'services';

export interface SearchResult {
  term: string;
  data: CaseSummary[];
}

export interface LookupState {
  search?: string;
  result?: SearchResult;
  curCase?: Case;
  curFeedbacks?: Feedback[];
  curConfig?: QueueConfiguration;
}

export type LookupAction =
  | { type: 'SEARCH'; search: string; result?: SearchResult }
  | { type: 'SELECT'; curCase: Case; curFeedbacks: Feedback[]; curConfig: QueueConfiguration }
  | { type: 'CLEAR' };

export const lookupReducer: Reducer<LookupState, LookupAction> = (
  state: LookupState,
  action: LookupAction
): LookupState => {
  switch (action.type) {
    case 'CLEAR':
      return { ...state, curCase: undefined, curConfig: undefined, curFeedbacks: undefined };
    case 'SEARCH':
      return {
        ...state,
        search: action.search,
        result: action.result
      };
    case 'SELECT':
      return { ...state, curCase: action.curCase, curConfig: action.curConfig, curFeedbacks: action.curFeedbacks };
  }
};

export interface LookupContextProps {
  state: LookupState;
  dispatch: (action: LookupAction) => void;
}

export const LookupContext = createContext<LookupContextProps>({} as LookupContextProps);
